<template>
  <div class="rhcn-cascader">
    <el-cascader
      v-model="innerValue"
      :options="options"
      :separator="separator"
      @change="handleChange"
      clearable
      filterable
      popper-class="rhcn-cascader-dropdown">
      <template #default="{ data }">
        <div class="el-cascader-node-content" :class="[data.type === 'title' ? 'title' : 'label']">{{data.label}}</div>
      </template>
    </el-cascader>
  </div>
</template>

<script>
export default {
  name: 'RhcnCascader',
  props: {
    value: { // 选中的值
      type: String,
      default: '',
    },
    options: { // 下拉菜单选项
      type: Array,
      default: () => [],
    },
    separator: {
      type: String,
      default: ' / ',
    },
  },
  data() {
    return {
      innerValue: this.value ? this.value.split('***') : [],
    };
  },
  watch: {
    value() {
      this.innerValue = this.value ? this.value.split('***') : [];
    },
  },
  methods: {
    handleChange() {
      this.$emit('update:value', this.innerValue.join('***'));
      this.$emit('change', this.innerValue.join('***'));
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.rhcn-cascader {
  //
}

.rhcn-cascader-dropdown {
  .el-cascader-panel {
    min-width: 450px;
    .el-cascader-menu {
      // flex: 1;
    }
    .el-cascader-menu__list {
      padding: 0;
      .el-cascader-node {
        padding-left: 0;
        padding-right: 0;
        min-height: 34px;
        height: auto;
        cursor: initial;

        &:hover, &:focus {
          background-color: transparent;
        }

        &.is-active {
          background-color: transparent;

          .el-cascader-node__label {
            color: $color-cascader-active-path;
          }

          .el-cascader-node__prefix {
            display: inline-block;
            left: 4px;
          }
        }

        .el-cascader-node__label {
          padding-right: 0;
        }

        .el-cascader-node-content {
          //
          &.title {
            padding-left: 12px;
            height: 39px;
            display: flex;
            align-items: center;
          }

          &.label {
            padding: 7px 0;
            padding-left: 20px;
            padding-right: 40px;
            cursor: pointer;
            white-space: pre-line;
            word-break: break-all;
            line-height: 1.5;

            &:hover, &:focus {
              background-color: $color-default;
            }
          }
        }
      }
    }
    }
}
</style>
